import axios from 'axios';
import { CreatePhysicalProductRequest } from '../../common/model/dto/physical-product/create-physical-product-request';
import { ADMIN_PHYSICAL_PRODUCTS_ROUTE } from '../../api/backend';
import { UpdatePhysicalProductRequest } from '../../common/model/dto/physical-product/update-physical-product-request';
import { Paginated } from '../../common/types';
import { PhysicalProduct } from '../../common/model/dto/physical-product/physical-product';

export const getPhysicalProducts = async (
  query: string
): Promise<Paginated<PhysicalProduct>> => {
  const { data } = await axios.get(
    `/${ADMIN_PHYSICAL_PRODUCTS_ROUTE}?${query}`
  );

  return data;
};

export const getPhysicalProductById = async (
  id: string
): Promise<PhysicalProduct> => {
  const { data } = await axios.get(`/${ADMIN_PHYSICAL_PRODUCTS_ROUTE}/${id}`);

  return data;
};

export const createPhysicalProduct = async (
  createPhysicalProductRequest: CreatePhysicalProductRequest
) => {
  const { data } = await axios.post(
    `${ADMIN_PHYSICAL_PRODUCTS_ROUTE}`,
    createPhysicalProductRequest
  );

  return data;
};

export const updatePhysicalProduct = async (
  id: string,
  updatePhysicalProductRequest: UpdatePhysicalProductRequest
) => {
  const { data } = await axios.patch(
    `${ADMIN_PHYSICAL_PRODUCTS_ROUTE}/${id}`,
    updatePhysicalProductRequest
  );

  return data;
};

export const deletePhysicalProduct = async (id: string): Promise<void> => {
  return await axios.delete(`${ADMIN_PHYSICAL_PRODUCTS_ROUTE}/${id}`);
};
